import React from 'react';

/** Small text “+ Add New” for expandable profile app section headers. */
const ProfileSectionAddButton = ({ title, ariaLabel, label = 'Add New', onClick }) => {
  const accessible = ariaLabel || title || label;
  return (
    <button
      type="button"
      className="profile-section-add-btn"
      onClick={(e) => {
        e.stopPropagation();
        onClick?.(e);
      }}
      title={title || accessible}
      aria-label={accessible}
    >
      + {label}
    </button>
  );
};

export default ProfileSectionAddButton;
